import { assignKey } from "../assignKey";

/**
 * Assign second object symbols to first
 */
export const assignSymbols = (
	target: Record<string | symbol, any>,
	source: Record<string | symbol, any>,
) =>
	Object.getOwnPropertySymbols(source).forEach((symbol) =>
		assignKey(target, source, symbol),
	);
